/**
 * Shared {N} placeholder interpolation for as-text and the localization
 * mixin, so both fill in vars the same way.
 */

export type InterpolationVar = string | number | { dictKey: string; defaultText?: string } | undefined | null;

// Replaces {0}, {1}, ... with the matching entry from vars. A var can be a
// plain string, a number (e.g. a count), or a { dictKey, defaultText } object
// resolved via resolveDictKey (falling back to defaultText). A missing var
// becomes ''.
export function interpolateText(
  text: string,
  vars: InterpolationVar[],
  resolveDictKey?: (dictKey: string) => string | null
): string {
  return text.replace(/\{(\d+)\}/g, (_match, indexStr) => {
    const v = vars[parseInt(indexStr, 10)];
    if (v === undefined || v === null) return '';
    if (typeof v === 'string') return v;
    if (typeof v === 'number') return String(v);
    if (typeof v === 'object' && v.dictKey) {
      return resolveDictKey?.(v.dictKey) ?? v.defaultText ?? '';
    }
    return '';
  });
}
